import { Flex, Loader, Paper } from "@mantine/core";

export const LoaderComponent = () => (
  <Paper p={"lg"} radius={"lg"} my={"xl"} mih={"80vh"}>
    <Flex align={"center"} justify={"center"} mih={"inherit"}>
      <Loader role="status" aria-label="Laddar sidan" />
    </Flex>
  </Paper>
);
